var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKlaviyo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 95.5",
    style: {
      enableBackground: "new 0 0 150 95.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1503.416,
    y1: 3552.7449,
    x2: 1503.416,
    y2: 3417.8276,
    gradientTransform: "matrix(0.7071 0 0 0.7071 -988.4218 -2416.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE01E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1373,
    style: {
      stopColor: "#CADD32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    style: {
      stopColor: "#8FD848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4774,
    style: {
      stopColor: "#5ED55B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    style: {
      stopColor: "#37D269"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7779,
    style: {
      stopColor: "#1CD073"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9044,
    style: {
      stopColor: "#0BCF7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#05CE7C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,43.3l63.4-42c2.5-1.6,6.4-1.6,8.9,0l63.4,42c3.8,2.5,3.8,6.6,0,9.1L134,58c-12.5-19.7-34.5-32.7-59.4-32.7 c-25,0-46.9,13.1-59.4,32.7l-8.5-5.6C3,49.9,3,45.7,6.8,43.3z M74.6,42.8c-18.9,0-35.4,10-44.8,24.8l14.6,9.7 c6.2-10.2,17.3-17,30.1-17c12.7,0,23.9,6.8,30.1,17l14.6-9.7C110.1,52.8,93.5,42.8,74.6,42.8z M74.6,77.9c-6.6,0-12.4,3.7-15.5,9.1 l9.8,6.4c1.6,1.3,3.5,2.1,5.7,2.1s4.2-0.8,5.7-2.1l9.8-6.4C87.2,81.7,81.3,77.9,74.6,77.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaviyo);
export default __webpack_public_path__ + "static/media/klaviyo.daf276e810aa8f4578e06bb9dd34f53f.svg";
export { ForwardRef as ReactComponent };